import React, { useState, useEffect } from 'react';
import { Button, Form, Upload, Modal, App, Input, Space } from 'antd';
import { EditOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './ProductDetailTemplate6.module.scss';
import type { UploadFile, UploadProps } from 'antd';
import { useAppSelector } from '@/store/hooks';
import icon1 from '@/assets/images/templete6.jpg';
import { useTranslation } from 'react-i18next';
interface SpecItem {
  leftTitle: string;
  rightTitle: string;
}

export interface ProductDetailTemplate6Props {
  data: {
    name: string;
    title: string;
    contentList: SpecItem[];
  };
  onChange?: (data: any, selfIndex: number) => void;
  editable?: boolean;
  selfIndex?: number;
  thumbnailMode?: boolean;//是否是缩略图模式
  onDelete?: (selfIndex: number) => void;
}

const ProductDetailTemplate6: React.FC<ProductDetailTemplate6Props> = ({  
  
  data,
  onChange,
  editable = true,
  selfIndex = 0,
  thumbnailMode = false,
  onDelete
}) => {
  const { message } = App.useApp();
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);

  // 编辑表单数据
  const [title, setTitle] = useState(data?.title || '');
  const [contentList, setContentList] = useState<SpecItem[]>(data?.contentList || []);

  // 获取token
  const token = useAppSelector((state) => state.user.token);

  // 初始化数据
  useEffect(() => {
    if (data) {
      setTitle(data.title || '');
      setContentList(data.contentList || []);
    }
  }, [data]);

  // 打开编辑模式
  const handleEdit = () => {
    setIsEditing(true);
    form.setFieldsValue({
      title,
      contentList: contentList.length > 0 ? contentList : [{ leftTitle: '', rightTitle: '' }]
    });
  };

  // 保存编辑
  const handleSave = () => {
    form.validateFields().then(values => {
      const updatedData = {
        ...data,
        title: values.title,
        contentList: values.contentList.filter((item: SpecItem) => item.leftTitle || item.rightTitle)
      };

      onChange && onChange(updatedData, selfIndex);
      setTitle(values.title);
      setContentList(values.contentList.filter((item: SpecItem) => item.leftTitle || item.rightTitle));
      setIsEditing(false);
      message.success(t("ProductDetailTemplate6.Templateupdatedsuccessfully"));
    });
  };

  // 取消编辑
  const handleCancel = () => {
    setIsEditing(false);
  };

  // 添加规格项
  const addSpecItem = () => {
    const items = form.getFieldValue('contentList') || [];
    form.setFieldsValue({
      contentList: [...items, { leftTitle: '', rightTitle: '' }]
    });
  };

  // 删除规格项
  const removeSpecItem = (index: number) => {
    const items = form.getFieldValue('contentList') || [];
    if (items.length <= 1) {
      message.warning(t("ProductDetailTemplate6.Atleast"));
      return;
    }
    form.setFieldsValue({
      contentList: items.filter((_: any, i: number) => i !== index)
    });
  };

  return (
    <div className={styles['template-container']}>
      {thumbnailMode ? (
        <div className={styles['template-thumbnail']} onClick={handleEdit}>
          <div className={styles['thumbnail-number']}>
            {selfIndex + 1}
          </div>
          <img className={styles['thumbnail-image']} src={icon1 || ''} alt="" />
          <div className={styles['thumbnail-actions']}>
            <Button 
              size="small"
              danger
              className={styles['delete-btn']}
              onClick={(e) => {
                e.stopPropagation();
                // 这里需要调用删除函数，但需要从父组件传入
                onDelete && onDelete(selfIndex);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles['template-content']}>
          <div className={styles['template-title']}>{title}</div>
          <div className={styles['specs-container']}>
            {contentList.map((item, index) => (
              <div key={index} className={styles['spec-item']}>
                <div className={styles['spec-left']}>{item.leftTitle}</div>
                <div className={styles['spec-right']}>{item.rightTitle}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      

      {/* 编辑模式 */}
      {isEditing && (
        <Modal
          title={t("ProductDetailTemplate6.EditSpecifications")}
          open={isEditing}
          onOk={handleSave}
          onCancel={handleCancel}
          okText={t("ProductDetailTemplate6.Save")}
          cancelText={t("ProductDetailTemplate6.Cancel")}
          className={styles['edit-modal']}
          width={700}
        >
          <Form
            form={form}
            layout="vertical"
            initialValues={{
              title,
              contentList: contentList.length > 0 ? contentList : [{ leftTitle: '', rightTitle: '' }]
            }}
          >
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: t("ProductDetailTemplate6.Pleaseentertitle") }]}
            >
              <Input placeholder={t("ProductDetailTemplate6.Entertitle")} maxLength={50} />
            </Form.Item>

            <Form.List name="contentList">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key} className={styles['spec-form-item']}>
                      <Space style={{ width: '100%', display: 'flex' }}>
                        <Form.Item
                          {...restField}
                          name={[name, 'leftTitle']}
                          label={t("ProductDetailTemplate6.Label")}
                          rules={[{ required: true, message: t("ProductDetailTemplate6.Pleaseenterlabel") }]}
                          style={{ flex: 1 }}
                        >
                          <Input placeholder={t("ProductDetailTemplate6.egHeight")} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'rightTitle']}
                          label={t("ProductDetailTemplate6.Value")}
                          rules={[{ required: true, message: t("ProductDetailTemplate6.Pleaseentervalue") }]}
                          style={{ flex: 1 }}
                        >
                          <Input placeholder="e.g. 555mm" />
                        </Form.Item>
                        {fields.length > 1 && (
                          <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => removeSpecItem(name)}
                            className={styles['delete-button']}
                            style={{ marginTop: 32 }}
                          />
                        )}
                      </Space>
                    </div>
                  ))}
                  <Form.Item>
                    <Button 
                      type="dashed" 
                      onClick={addSpecItem} 
                      block 
                      icon={<PlusOutlined />}
                    >
                     {t("ProductDetailTemplate6.Add Specification")}
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default ProductDetailTemplate6; 